import React from 'react';

import { Button } from '@rbilabs/components-library/build/components/button';
import { Icon } from '@rbilabs/components-library/build/components/icon';

export const MenuCardButton = props => (
  <Button {...props} startIcon={<Icon icon="next" height="16px" width="16px" aria-hidden />} />
);
